import {
    RaikoBaseCardContainer,
    RaikoGridTwoColumn,
    RaikoSectionContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {ReportBox, ReportsItemTypes} from "../../../raikoComponents/reportBox/ReportBox";
import icExcel from "../../../assets/svg/microsoft-excel.svg";
import icPdf from "../../../assets/svg/pdf.svg";
import {useParams} from "react-router-dom";
import {useAuthState} from "../../../context/AuthContext";
import {LoanService} from "../../../serverService/loan/LoanService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {doDownloadFile} from "../../../util/DownloadHelper";

export default function LoanDetailReports() {

    const {id: loanId} = useParams()

    const {fundID} = useAuthState()

    const service = new LoanService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    function getReport(type) {
        loading.show()
        service.getLoanReportFile(
            fundID, loanId, type.id
        ).then(response => {
            doDownloadFile(response, `گزارش وضعیت وام ${loanId}`, type.type)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer title={"گزارش وضعیت وام"}>
                <RaikoGridTwoColumn>
                    <ReportBox
                        label={"EXCEL"}
                        icon={icExcel}
                        action={_ => {
                            getReport(ReportsItemTypes.XLSX);
                        }}
                    />

                    <ReportBox
                        label={"PDF"}
                        icon={icPdf}
                        action={_ => {
                            getReport(ReportsItemTypes.PDF);
                        }}
                    />
                </RaikoGridTwoColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}
